import { Fragment } from 'react';
import { PartitionedSessionList } from '../model/Session';
import { SessionList } from './SessionList';
import { formatDate, formatWeekday } from '../util/dateUtil';

interface Props {
    short?: boolean;

    partitionedSessions: PartitionedSessionList;
    visiblePartitions?: string[];
}

export const PartitionedSessionTable = ({ short, partitionedSessions, visiblePartitions }: Props) => {
    const dayList = visiblePartitions ?? Object.keys(partitionedSessions).sort();

    return (
        <div>
            {dayList.map((key) => (
                <Fragment key={key}>
                    <div className="zww-day-row">
                        <span>
                            {formatWeekday(key)} | {formatDate(key)}
                        </span>
                    </div>
                    <SessionList
                        shortListingHref={short ? `/programm-2026/#/sessions/by-date/${key}` : undefined}
                        sessions={partitionedSessions[key]}
                    />
                </Fragment>
            ))}
        </div>
    );
};
